import { Injectable } from '@angular/core';
import { GraphqlService } from 'src/app/services/graphql/graphql.service';
import { ScopeSequenceSkill } from '../graphql/scope-sequence-skills-response';
import { SkillResponse } from 'src/app/home/scope-sequence/models/skill-response.model';
import { SearchApiService } from '../search-api/search-api.service';

@Injectable({ providedIn: 'root' })
export class StandardService {
  constructor(
    private graphqlService: GraphqlService,
    private searchApi: SearchApiService
  ) { }

  public async getScopeSequenceSkills(standardId: string): Promise<ScopeSequenceSkill[]> {
    let scopeSequenceResponse = await this.graphqlService.getScopeSequenceSkills(standardId);

    if (scopeSequenceResponse.length > 0) {
      let sortedSkills = this.sortSkillList(scopeSequenceResponse);
      
      const renaissanceSkillIds = sortedSkills.map(skill => skill.skillId);
      const renaissanceSkills = await this.searchApi.getSkills(renaissanceSkillIds);
      sortedSkills = this.updateScopeSequenceThumbnailDescription(renaissanceSkills, sortedSkills);

      return sortedSkills;
    } else {
      throw new Error(`No scope and sequences skills found for standardId ${standardId}`);
    }
  }

  public sortSkillList(scopeSequenceSkills: ScopeSequenceSkill[]): ScopeSequenceSkill[] {
    return [...scopeSequenceSkills].sort((a, b) => a.skillName.localeCompare(b.skillName));
  }

  private updateScopeSequenceThumbnailDescription(skills: SkillResponse[], scopeSequenceSkills: ScopeSequenceSkill[]): ScopeSequenceSkill[] {
    const uniqueSkillsSet = new Set<string>();

    const updatedSkills = scopeSequenceSkills.map(scopeSequenceSkill => {
      const matchingSkill = skills.find(skill => {
        return skill.renaissance_skill_id.some(skillRenaissanceId => {
          return scopeSequenceSkill.skillId === skillRenaissanceId;
        });
      });

      if (matchingSkill) {
        return this.updateSkillWithMatchingData(scopeSequenceSkill, matchingSkill, uniqueSkillsSet);
      }

      return scopeSequenceSkill;
    });

    return updatedSkills;
  }

  private updateSkillWithMatchingData(skill: ScopeSequenceSkill, matchingSkill: SkillResponse, uniqueSkillsSet: Set<string>): ScopeSequenceSkill {
    const uniqueKey = `${matchingSkill.thumbnail_url}${matchingSkill.description || ''}`;
    const isUnique = !uniqueSkillsSet.has(uniqueKey);
    uniqueSkillsSet.add(uniqueKey);

    const lessonType = matchingSkill?.tags?.find(tag => tag.key === 'lesson_types')?.value[0] || 'Lesson';

    return {
      ...skill,
      lessonType,
      description: isUnique ? matchingSkill?.description || '' : '',
      thumbnailUrl: isUnique ? matchingSkill?.thumbnail_url || 'assets/nothumbnail.png' : '',
      url: matchingSkill?.url || '',
    };
  }
}
